'use client';
import React from 'react';
import { SHAME_STATS } from './ShameData';

export default function ShameHero() {
  return (
    <div className="relative mb-10 overflow-hidden rounded-2xl p-8"
      style={{
        background: 'linear-gradient(135deg, rgba(20,5,5,0.98) 0%, rgba(30,8,8,0.95) 40%, rgba(20,10,5,0.98) 100%)',
        border: '1px solid rgba(239,68,68,0.2)',
        boxShadow: '0 0 60px rgba(239,68,68,0.08), inset 0 1px 0 rgba(255,255,255,0.04)',
      }}
    >
      {/* Background glow blobs */}
      <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(239,68,68,0.08) 0%, transparent 70%)', filter: 'blur(40px)' }} />
      <div className="absolute bottom-0 right-1/4 w-48 h-48 rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(249,115,22,0.07) 0%, transparent 70%)', filter: 'blur(40px)' }} />
      <div className="relative z-10">
        {/* Label */}
        <div className="flex items-center gap-2 mb-4">
          <span className="text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full"
            style={{ background: 'rgba(239,68,68,0.12)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.25)', letterSpacing: '0.1em' }}>
            😈 Wall of Infamy
          </span>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <h1 className="text-5xl sm:text-6xl font-extrabold mb-3 leading-none"
              style={{
                background: 'linear-gradient(135deg, #ef4444 0%, #f97316 50%, #fbbf24 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>
              Hall of Shame
            </h1>
            <p className="text-sm max-w-lg leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
              Celebrating the community's most questionable habits, chaotic tendencies, and deeply suspicious WhatsApp behavior. No judgment. Okay, maybe a little.
            </p>
          </div>

          {/* Shame score badge */}
          <div className="flex-shrink-0 flex items-center gap-3 px-5 py-3 rounded-xl"
            style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)' }}>
            <span className="text-3xl">🏴‍☠️</span>
            <div>
              <div className="text-xs font-semibold uppercase tracking-wider" style={{ color: 'rgba(255,255,255,0.4)' }}>Chaos Level</div>
              <div className="text-xl font-extrabold" style={{ color: '#ef4444' }}>MAXIMUM</div>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
          {SHAME_STATS?.map((s) => (
            <div key={s?.label} className="rounded-xl p-4 text-center"
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="text-2xl mb-1">{s?.icon}</div>
              <div className="text-xl font-extrabold mb-0.5" style={{ color: '#f97316' }}>{s?.value}</div>
              <div className="text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>{s?.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
